import { L10n } from "@syncfusion/ej2-base";
import { useTranslation } from "react-i18next";
import { ProjectThresholdDTO } from "../../../apiclients/bstinsights";
import { DataGrid, renderRow, Tooltip } from "@bst/react-ui";
import { useNLMProjectOverridesGrid } from "../Hooks/useNLMProjectOverridesGrid";
import { AddProjectOverrideButton } from "../Components/AddProjectOverrideButton";
import { NLMOverrideErrorModal } from './NLMOverrideErrorModal';

export const NLMProjectOverrides = () => {
  const {
    renderKey,
    ref,
    rows,
    columns,
    sort,
    handleScroll,
    handleAddOverride,
    handleColumnResize,
    handleColumnResizeStart,
    handleColumnResizeEnd,
    showOverrideError,
    handleNLMErrorModalClose
  } = useNLMProjectOverridesGrid();

  const { t } = useTranslation();

  L10n.load({
    "en-US": {
      dropdowns: {
        noRecordsTemplate: t("dropdowns.noRecordsTemplate"),
      },
    },
  });

  return (
    <div className="nlm_project_overrides-settings">
      <div className="title" data-testid="nlm_project_overrides-title">
        <div className="settings-title">
          {t("nlmsettings.projectsNLMOverrides")}
        </div>
      </div>

      {rows.length === 0 && (
        <div className="no_project_overrides">
          <span>
            {t('nlmsettings.noProjectOverrides')}
          </span>
          <Tooltip content={t("nlmsettings.project_override_addrow_text")}>
            <button
              className="button button--primary"
              aria-label="Add Project"
              data-testid="nlm_project_override-add-projects"
              onClick={handleAddOverride}
            >
              {t("nlmsettings.add_project")}
              <i className="icon icon-add" />
            </button>
          </Tooltip>
        </div>
      )}

      {rows.length > 0 && (
        <>
          <DataGrid
            key={renderKey}
            ref={ref}
            data-testid="project-override-grid"
            className="nlm_project_override-grid"
            rows={rows as ProjectThresholdDTO[]}
            columns={columns}
            sortColumns={sort ? [sort] : []}
            renderers={{ renderRow }}
            rowHeight={56}
            headerRowHeight={85}
            rowKeyGetter={(row) => row.projectId!}
            onScroll={handleScroll}
            onColumnResize={handleColumnResize}
            onColumnResizeStart={handleColumnResizeStart}
            onColumnResizeEnd={handleColumnResizeEnd}
            onCellClick={(cell, event) => {
              // Single click cell editablity
              event.preventGridDefault();
              cell.selectCell(true);
            }}
            defaultColumnOptions={{
              resizable: true,
              sortable: true,
              minWidth: 196,
            }}
          />

          <AddProjectOverrideButton onAddOverride={handleAddOverride} />
        </>
      )}
      <NLMOverrideErrorModal
        show={showOverrideError}
        handleClose={handleNLMErrorModalClose}
      />
    </div>
  );
};

export default NLMProjectOverrides;
